import { inject } from "vue";

export function useConfirm() {
  // Obtener la función $confirm proporcionada por App.vue
  const $confirm = inject("$confirm");
  
  if (!$confirm) {
    console.warn("Confirm dialog not available. Make sure ConfirmDialog is mounted in App.vue");
    return {
      confirm: async () => false
    };
  }

  return {
    confirm: $confirm
  };
}
